import {props} from '@ngrx/store';
import {createActionWithCorrelation} from '@kion/ngrx-helper';
import {Role} from '@kion/data-models';

export const loadByUserIdSuccess = createActionWithCorrelation(
  "[Role] load by userId success",
  props<{ roles: Role[] }>()
);
export const loadByUserIdError = createActionWithCorrelation(
  "[Role] load by userId error",
  props<{ error: any }>()
);
export const loadByUserId = createActionWithCorrelation(
  "[Role] load by userId",
  props<{ userId: string, currentUser: boolean }>(),
  loadByUserIdSuccess.type,
  loadByUserIdError.type
);

export const removeUnusedRolesFromUser = createActionWithCorrelation(
  "[Role] remove unused roles from user",
  props<{roles: Role[]}>()
)

export const setRolesSuccess = createActionWithCorrelation(
  "[Role] set roles success",
  props<{ roles: Role[] }>()
);
export const setRolesError = createActionWithCorrelation(
  "[Role] set roles error",
  props<{ error: any }>()
);
export const setRoles = createActionWithCorrelation(
  "[Role] set roles",
  props<{ userId: string, roles: Partial<Role>[] }>(),
  setRolesSuccess.type,
  setRolesError.type
);

export const revokeRolesSuccess = createActionWithCorrelation(
  "[Role] revoke roles success",
  props<{ roles: Partial<Role>[] }>()
);
export const revokeRolesError = createActionWithCorrelation(
  "[Role] revoke roles error",
  props<{ error: any }>()
);
export const revokeRoles = createActionWithCorrelation(
  "[Role] revoke roles",
  props<{ userId: string, roles: Partial<Role>[] }>(),
  revokeRolesSuccess.type,
  revokeRolesError.type
);
